export enum ACTION_TYPES {
  SET_READONLY_FIELDS = 'CM/CASE/READONLY_FIELDS/SET',
  SET_PEPPER_UPLOAD_DATE = 'CM/CASE/READONLY_FIELDS/SET_PEPPER_UPLOAD_DATE',
}
